// @flow

import React from 'react';
import PinLandingRecipeCredit from 'app/common/react/components/growth/activation/PinLanding/PinLandingRecipeCredit';
import ProductPinTag from 'app/common/react/components/growth/unauth/PinLandingCloseup/ProductPinTag';
import type { Pin as PinFlowType } from 'app/packages/pinterest-flow-types/pin';
import { isProductPin } from 'app/common/react/components/growth/unauth/pin/RichSnippet/RichPinUtil';
import { isRecipe } from 'app/common/lib/RecipeUtils';
import { pinPropType } from 'app/common/react/components/growth/unauth/lib/PropTypes';

const PIN_GRID_PRODUCT_PIN_WIDTH = 215;
const PIN_GRID_PRODUCT_PIN_TAG_GAP = 10;
const PIN_GRID_PRODUCT_PIN_LINK_WIDTH = 210;

type Props = {
  pin: PinFlowType,
  recipe?: Object,
  inRemoveInlineGroup: boolean,
};

const RichPinAttribution = ({ pin, recipe = {}, inRemoveInlineGroup }: Props) => {
  const renderProdPinNotation = () => (
    <ProductPinTag
      pin={pin}
      fullWidth={PIN_GRID_PRODUCT_PIN_WIDTH}
      iconSize={PIN_GRID_PRODUCT_PIN_TAG_GAP}
      linkWidth={PIN_GRID_PRODUCT_PIN_LINK_WIDTH}
      showMoreInfoButton={false}
      inRemoveInlineGroup={inRemoveInlineGroup}
    />
  );

  const renderRecipePinNotation = () => (
    <PinLandingRecipeCredit
      pin={pin}
      recipe={recipe}
      ratingStarSize={12}
      isInPinGrid
      isShowReviewText={false}
    />
  );

  // showing only recipe pin notation or product pin notation
  if (isRecipe(pin)) {
    return renderRecipePinNotation();
  }

  if (isProductPin(pin)) {
    return renderProdPinNotation();
  }

  return null;
};

RichPinAttribution.propTypes = {
  pin: pinPropType,
};

export default RichPinAttribution;
